import { render } from "./etBtnAdd.vue?vue&type=template&id=8c63711e"
import script from "./etBtnAdd.vue?vue&type=script&lang=js"
export * from "./etBtnAdd.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__